import api from '@/plugins/api';

export const otpService = {
    send(identifier, channel) {
        return api.post('/otps', { identifier: identifier.trim(), channel });
    },

    verify(identifier, code) {
        return api.post('/otps/verify', { identifier: identifier.trim(), code });
    },
};